export enum EventTypeEnum {
  CLICK = 'clk',
  PAGE_OPEN = 'pageOpen',
  LOAD_TIME = 'loadTime',
  VISIT_TIME = 'visitTime',
  SEARCH = 'search',
}

export enum FunctionIdEnum {
  /**
   * 页面事件
   */
  globalLayer_page_open = 'globalLayer_page_open',
  /**
   * 点击Layers菜单
   */
  globalLayer_nav_showLayers = 'globalLayer_nav_showLayers',
  /**
   * 展示可添加图层列表
   */
  globalLayer_layers_showAllLayers = 'globalLayer_layers_showAllLayers',
  /**
   * 搜索图层
   */
  globalLayer_layers_searchLayer = 'globalLayer_layers_searchLayer',
  /**
   * 切换列表样式
   */
  globalLayer_layers_listStyleSwitch = 'globalLayer_layers_listStyleSwitch',
  /**
   * 添加图层
   */
  globalLayer_layers_addNewLayer = 'globalLayer_layers_addNewLayer',
  /**
   * 切换公开、私密列表显示
   */
  globalLayer_layers_listTypeSwitch = 'globalLayer_layers_listTypeSwitch',
  /**
   * 点击分页
   */
  globalLayer_layers_gotoPage = 'globalLayer_layers_gotoPage',
  /**
   * 导入外部数据源
   */
  globalLayer_layers_importFromUrl = 'globalLayer_layers_importFromUrl',
  /**
   * 添加历史数据源
   */
  globalLayer_layers_addHistoricalConnection = 'globalLayer_layers_addHistoricalConnection',
  /**
   * 测试外部数据链接
   */
  globalLayer_layers_testConnection = 'globalLayer_layers_testConnection',
  /**
   * 删除外部图层
   */
  globalLayer_layers_deleteConnection = 'globalLayer_layers_deleteConnection',
  /**
   * 展示当前显示图层列表
   */
  globalLayer_layers_showDisplayedLayers = 'globalLayer_layers_showDisplayedLayers',
  /**
   * 切换地球上图层的显隐
   */
  globalLayer_layers_toggleLayersVisible = 'globalLayer_layers_toggleLayersVisible',
  /**
   * 从地球上移除图层
   */
  globalLayer_layers_removeLayer = 'globalLayer_layers_removeLayer',
  /**
   * 刷新地球上的图层
   */
  globalLayer_layers_refreshLayer = 'globalLayer_layers_refreshLayer',
  /**
   * 展开图层的子图层
   */
  globalLayer_layers_expandSubLayers = 'globalLayer_layers_expandSubLayers',
  /**
   * 切换地球上图层子图层的显隐
   */
  globalLayer_layers_toggleSubLayersVisible = 'globalLayer_layers_toggleSubLayersVisible',
  /**
   * 显示图例列表
   */
  globalLayer_nav_showLegends = 'globalLayer_nav_showLegends',
  /**
   * 切换图例展开收起状态
   */
  globalLayer_legends_toggleLegendShow = 'globalLayer_legends_toggleLegendShow',
  /**
   * 显示导出页面
   */
  globalLayer_nav_showExport = 'globalLayer_nav_showExport',
  /**
   * 选择缩放级别
   */
  globalLayer_export_selectZoom = 'globalLayer_export_selectZoom',
  /**
   * 选择可视范围
   */
  globalLayer_export_selectBounds = 'globalLayer_export_selectBounds',
  /**
   * 选择指北针显示
   */
  globalLayer_export_showNorth = 'globalLayer_export_showNorth',
  /**
   * 选择经纬网显示
   */
  globalLayer_export_showGratiules = 'globalLayer_export_showGratiules',
  /**
   * 选择鸟瞰图展示
   */
  globalLayer_export_showMiniMap = 'globalLayer_export_showMiniMap',
  /**
   * 选择导出文件格式
   */
  globalLayer_export_selectExportFormat = 'globalLayer_export_selectExportFormat',
  /**
   * 导出文件
   */
  globalLayer_export_exportMap = 'globalLayer_export_exportMap',
  /**
   * 搜索经纬度和位置
   */
  globalLayer_earth_searchLocation = 'globalLayer_earth_searchLocation',
  /**
   * 切换底图
   */
  globalLayer_earth_changeBaseMap = 'globalLayer_earth_changeBaseMap',
  /**
   * 显示兴趣点详情
   */
  globalLayer_earth_identifyLocation = 'globalLayer_earth_identifyLocation',
  /**
   * 量算
   */
  globalLayer_earth_calculate = 'globalLayer_earth_calculate',
  /**
   * 显示图库
   */
  globalLayer_header_showGallery = 'globalLayer_header_showGallery',
  /**
   * 创建地图
   */
  globalLayer_header_createMap = 'globalLayer_header_createMap',
  /**
   * 切换中英文
   */
  globalLayer_header_switchLanguage = 'globalLayer_header_switchLanguage',
  /**
   * 登录注册
   */
  globalLayer_header_login = 'globalLayer_header_login',
  /**
   * 显示首页
   */
  globalLayer_header_showHome = 'globalLayer_header_showHome',
}
